<h1 mat-dialog-title>Remove carousel item</h1>
<div mat-dialog-content>
  Are you sure you want to remove the following carousel item ?
  <br/><br/>
  <strong>{{data.name}}</strong>
</div>
<div mat-dialog-actions >
  <button (click)="onConfirm(data.id)" mat-button cdkFocusInitial>Ok</button>
  <button mat-button mat-dialog-close>Cancel</button>
</div>

